import { useEffect } from "react";

const TrackingScript = ({ onTrackingComplete }) => {
  useEffect(() => {
    // Set global variables
    window.npf_d = "https://apply.mvn.edu.in";
    window.npf_c = "6093";
    window.npf_m = "1";

    // Create script
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "https://track.nopaperforms.com/js/track.js";

    script.onload = () => {
      console.log("Tracking loaded");
      if (onTrackingComplete) {
        onTrackingComplete();
      }
    };

    document.body.appendChild(script);

    // Cleanup
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [onTrackingComplete]);

  return null;
};

export default TrackingScript;